export const APPLICATION_PATHS = {
    ONTOLOGY_MANAGER: '/ontologymanager',
    TAXONOMY_MANAGER: '/vocabularymanager'
};

export const ENTITLEMENTS = {
    CREATE_ONTOLOGY_PROJECT: "https://grafsync.graphifi.com/schema/om-entitlement/createProject",
    CREATE_ONTOLOGY: "https://grafsync.graphifi.com/schema/om-entitlement/createOntology",
    EDIT_ONTOLOGY: "https://grafsync.graphifi.com/schema/om-entitlement/editOntology",
    EDIT_ONTOLOGY_PROJECT: "https://grafsync.graphifi.com/schema/om-entitlement/editProject",
    VIEW_ONTOLOGY: "https://grafsync.graphifi.com/schema/om-entitlement/viewOntology",
    VIEW_ONTOLOGY_PROJECT: "https://grafsync.graphifi.com/schema/om-entitlement/viewProject",
    CLEAR_FLOATING_ITEMS: "https://grafsync.graphifi.com/schema/vm-entitlement/canClearFloatingItems",
    CREATE_TAXONOMY_PROJECT: "https://grafsync.graphifi.com/schema/vm-entitlement/createProject",
    CREATE_TAXONOMY: "https://grafsync.graphifi.com/schema/vm-entitlement/createTaxonomy",
    EDIT_TAXONOMY: "https://grafsync.graphifi.com/schema/vm-entitlement/editTaxonomy",
    EDIT_TAXONOMY_PROJECT: "https://grafsync.graphifi.com/schema/vm-entitlement/editProject",
    VIEW_TAXONOMY: "https://grafsync.graphifi.com/schema/vm-entitlement/viewTaxonomy",
    VIEW_TAXONOMY_PROJECT: "https://grafsync.graphifi.com/schema/vm-entitlement/viewProject",
    MANAGE_SUGGESTIONS: "https://grafsync.graphifi.com/schema/vm-entitlement/manageSuggestionWorkflow",
    MAKE_SUGGESTIONS: "https://grafsync.graphifi.com/schema/vm-entitlement/makeSuggestions",
    VIEW_SUGGESTIONS: "https://grafsync.graphifi.com/schema/vm-entitlement/viewSuggestions",
    CREATE_DISCUSSION: "https://grafsync.graphifi.com/schema/vm-entitlement/discuss",
    VIEW_DISCUSSION: "https://grafsync.graphifi.com/schema/vm-entitlement/viewDiscussion",
    CREATE_TSV_TEMPLATE: "https://grafsync.graphifi.com/schema/vm-entitlement/createTsvTemplate",
    VIEW_TSV_TEMPLATE: "https://grafsync.graphifi.com/schema/vm-entitlement/viewTsvTemplate",
    ACTIVATE_WORKFLOW: "https://grafsync.graphifi.com/schema/vm-entitlement/activateCoreWorkflow",
    ASSIGN_WORKFLOW: "https://grafsync.graphifi.com/schema/vm-entitlement/assignWorkflow",
    MANAGE_WORKFLOW: "https://grafsync.graphifi.com/schema/vm-entitlement/manageCoreWorkflow",
    WORKFLOW_REVIEW: "https://grafsync.graphifi.com/schema/vm-entitlement/applyCoreWorkflowDraftStatus",
    BATCH_CHANGE_WORKFLOW_STATUS: "https://grafsync.graphifi.com/schema/vm-entitlement/batchChangeWorkflowStatus",
    CREATE_TASK: "https://graphifi.com/schema/entitlement/createTask",
    EDIT_TASK: "https://graphifi.com/schema/entitlement/editTask",
    VIEW_TASK: "https://graphifi.com/schema/entitlement/viewTask"
};

export const ENTITLEMENT_LABELS = {
    CLEAR_FLOATING_ITEMS: "Clear floating items",
    CREATE_ONTOLOGY_PROJECT: "Create ontology project",
    CREATE_ONTOLOGY: "Create ontology",
    EDIT_ONTOLOGY: "Edit ontology",
    EDIT_ONTOLOGY_PROJECT: "Edit ontology project",
    VIEW_ONTOLOGY: "View ontology",
    VIEW_ONTOLOGY_PROJECT: "View ontology project",
    CREATE_TAXONOMY_PROJECT: "Create vocabulary project",
    CREATE_TAXONOMY: "Create taxonomy",
    EDIT_TAXONOMY: "Edit taxonomy",
    EDIT_TAXONOMY_PROJECT: "Edit taxonomy project",
    VIEW_TAXONOMY: "View taxonomy",
    VIEW_TAXONOMY_PROJECT: "View vocabulary project",
    MANAGE_SUGGESTIONS: "Manage suggestion workflow",
    MAKE_SUGGESTIONS: "Make sugestions",
    CREATE_TSV_TEMPLATE: "Create TSV template",
    VIEW_TSV_TEMPLATE: "View TSV template",
    CAN_QUERY_PROJECT: "Can query project",
    EDIT_TASK: "Edit task",
    CREATE_TASK: "Create task",
    MANAGE_WORKFLOW: "Manage workflow"
};